import { render, staticRenderFns } from "./RecreateWebsiteDialog.vue?vue&type=template&id=81d19c74&"
import script from "./RecreateWebsiteDialog.vue?vue&type=script&lang=ts&"
export * from "./RecreateWebsiteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports